module.exports = __webpack_public_path__ + "static/media/29BDOS9.9c246687.jpg";